import { render, staticRenderFns } from "./PreSeasonSummary.vue?vue&type=template&id=54408113&"
import script from "./PreSeasonSummary.vue?vue&type=script&lang=js&"
export * from "./PreSeasonSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports